import React from 'react';
import { Row, Col, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import classnames from 'classnames';

export const RiskGradePopover = (props) => {
   
    let riskGradeTableView = props.riskGradeData.map(p => {
        return (
            <Row key={p.riskGrade} noGutters className={classnames('border-bottom mb-3 mb-sm-0', { 'bg-gray': props.highlighted === p.riskGrade })}>
                <Col xs="24" sm="3" className="p-1">{p.min}-{p.max}</Col>
                <Col xs="24" sm="4" className="p-1">{p.riskGrade}</Col>
                <Col xs="24" sm="4" className="p-1">{p.riskLevel}</Col>
                <Col xs="24" sm="11" className="p-1 text-truncate">{p.riskDescription}</Col>
            </Row>
        )
    });
    return (
        <Popover placement="bottom" isOpen={props.popoverOpen} target="Popover1" toggle={props.toggle}>
            <PopoverHeader>Risk Grades</PopoverHeader>
            <PopoverBody>
                <Row noGutters className="mb-3 custom-table-header d-sm-flex align-items-center">
                    <Col xs="24" sm="3" className="custom-table-header-title p-1">Range</Col>
                    <Col xs="24" sm="4" className="custom-table-header-title p-1">Grades</Col>
                    <Col xs="24" sm="4" className="custom-table-header-title p-1">Category</Col>
                    <Col xs="24" sm="11" className="custom-table-header-title p-1">Grade Description</Col>
                </Row>
                {riskGradeTableView}
            </PopoverBody>
        </Popover>
    );
}
            
export default RiskGradePopover;